<template>
	<div>
		<buttonlist @help="help" @search="search" @reflash="reflash" ref="SetBtn"></buttonlist>
		<div>
			<!--<el-button type="primary" size="mini" @click="createVouch">{{$t('getapi[13374]')}}</el-button>-->
			<el-button type="primary" size="mini" @click="createVouch" :disabled="selectData.length == 0">{{$t('getapi[13374]')}}</el-button>
		</div>
		<el-table
				id="xpane-0"
				:data="datajson"
				v-loading="loading"
				:highlight-current-row="false"
				show-overflow-tooltip="true"
				border
				stripe
				size="mini"
				header-row-class-name="headerclass"
				:height="tableHeight"
				@cell-dblclick="editInfo"
				tab-click="selectInfo(0)"
				@selection-change="handleSelectionChange"
				style="width: 100%; margin-top:0px"
				:header-cell-style="$limits.headerClass"
				ref="singleTable"
		>
			<el-table-column type="selection"></el-table-column>
			<el-table-column show-overflow-tooltip prop="Customer_Name" :label="$t('getapi[2958]')" width="100"></el-table-column>
			<el-table-column show-overflow-tooltip prop="Invoice_No" :label="$t('getapi[2992]')" width="100"></el-table-column>
			<el-table-column show-overflow-tooltip prop="Total_Amount" :label="$t('getapi[3733]')" width="100"></el-table-column>
			<el-table-column show-overflow-tooltip prop="Tax_Total_Amount" :label="$t('getapi[1611]')" width="100"></el-table-column>
			<el-table-column show-overflow-tooltip prop="other_cost" :label="$t('getapi[13491]')" width="100"></el-table-column>
			<el-table-column show-overflow-tooltip prop="IAbstract" :label="$t('getapi[7340]')" width="300"></el-table-column>
		</el-table>
		<!-- 分页 -->
		<el-row class="page">
			<el-col :span="16">
				<el-pagination
						@size-change="handleSizeChange"
						@current-change="handleCurrentChange"
						:page-sizes="[50, 100, 200, 300, 400]"
						:page-size="PageSize"
						background
						layout="total, sizes, prev, pager, next, jumper"
						:total="total"
				></el-pagination>
			</el-col>
			<el-col :span="8">
				<div style="text-align: right;line-height: 30px;color: #545c64;font-size: 95%;">{{$t('getapi[7980]')}}:{{ DbTbNames
					}}
				</div>
			</el-col>
		</el-row>
		<!-- 搜索弹框 -->
		<serce :isVisible="isVisible" queryData="salecreatevouch" ref="ser" @getser="serclick"></serce>

	</div>
</template>

<script>
    import Common from '@/components/Common';

    export default {
        name: '3_createvouch',
        computed: {
            tableHeight(){
                return this.$windowSize.tableHeight3 - Common.reduceTableHeight2
            }
        },
        data() {
            return {
                isVisible: false,
                DbTbNames: '', //表名
                datajson: [],
                PageIndex: 1,
                PageSize: this.$http.getPageSize('3_createvouch'),
                SelectIndex: 1,
                total: 0, // 数据总量
                loading: false, // 主表加载状态
                queryData: [], // 查询数组
                selectData: [],
                userData: [],
                user: '',
                scrollTop:0,

            };
        },
        create() {
        },
        beforeMount() {
            console.log('beforeMount');
            //this.getqwlist();
        },
        watch: {
            datajson: function () {
                let that = this
                that.$nextTick(function () {
                    that.$processdata.initForm(0)
                })
            },
        },
        mounted() {
            console.log('mounted');
            let that = this;
            that.userData = sessionStorage.getItem('userData');
            that.user = JSON.parse(that.userData).username;
            that.intidata();
            that.authority();
        },
        activated () {
            let that = this
            setTimeout(() => {
                that.$refs.singleTable.bodyWrapper.addEventListener('scroll', (res) => {
                    that.scrollTop = res.target.scrollTop
                },false)
            }, 5000);
            // 路由跳转回来滚动到离开时的位置
            this.$nextTick(()=> {
                setTimeout(() => {
                    this.$refs.singleTable.bodyWrapper.scrollTop =this.scrollTop;
                }, 13)
            })
        },
        methods: {
            help(){
                this.$refs.SetBtn.showHelp(this.$options.name,this.$t("getapi[1091]"),this.$t("getapi[11]"));
            },
            //按钮操作权限
            authority() {
                let that = this;
                that.$refs.SetBtn.SetButtonEnable('search,refresh');
            },
            //获取查询条件
            serclick(val) {
                this.queryData = val;
                this.intidata();
                this.authority();
            },
            //修改页数
            handleSizeChange(val) {
                this.PageSize = val;
                this.$http.savePageSize('3_createvouch',val)
                this.intidata();
                this.authority();
            },
            //跳页m
            handleCurrentChange(val) {
                this.PageIndex = val;
                this.intidata();
                this.authority();
            },
            //编辑
            editInfo(row) {
                let that = this;
            },
            // 获取数据
            intidata() {
                let that = this;
                that.loading = true;
                this.isVisible = false;
                let pm = {
                    query_Condition: '',
                    query_field_type: '',
                    query_field_name: '',
                    row_sign: '',
                    query_sort: ''
                };
                let parm = {
                    PageIndex: that.PageIndex,
                    PageSize: that.PageSize,
                    SelectIndex: that.SelectIndex,
                    Param: []
                };
                that.queryData.forEach(item => {
                    pm = {
                        row_sign: item.row_sign,
                        query_Condition: item.query_Condition,
                        query_sort: item.query_sort,
                        query_field_type: item.Query_Field_Type,
                        query_field_name: item.Query_Field_Name
                    };
                    parm.Param.push(pm);
                });
                that.$http.urlpost('GL/Receive/GetSaleInvoiceVouch', parm, function (res) {
                    console.log(res);
                    if (res.Success == 1) {
                        that.datajson = res.DataContent;
                        that.total = res.Totals;
                        that.DbTbNames = res.DbTbNames;
                    }
                    that.loading = false;
                    that.authority();
                });
            },
            // 获取查询条件
            getqwlist() {
                let that = this;
                that.$http.urlpost('Basic/Items/ItemQWList', {}, function (res) {
                    that.queryData = res.DataContent;
                });
            },

            handleSelectionChange(val) {
                let that = this;
                that.selectData = val
            },
            // 查询
            search() {
                this.isVisible = true;
                this.$refs.ser.clearInput(this.isVisible, 'salecreatevouch');
            },
            // 刷新
            reflash() {
                this.intidata();
            },
            beforeRoutJump(val,callback){
                let that = this
                if(that.oldFormInline != JSON.stringify(that.formInline)){
                    this.$confirm(that.$t('getapi[12830]'), that.$t('getapi[194]'), {
                        confirmButtonText: that.$t('getapi[1146]'),
                        cancelButtonText: that.$t('getapi[2054]'),
                        type: 'warning'
                    })
                        .then(() => {
                            that.isVisible = false
                            callback(true)
                        })
                        .catch(() => {
                            this.$message({
                                type: 'info',
                                message: that.$t('getapi[6096]')
                            });
                        });
                } else {
                    that.isVisible = false
                    callback(true)
                }
            },
			createVouch(){
                let that = this
                if(that.selectData[0].tax_total_amount == 0){
                    this.$confirm('税额为0，是否继续生成凭证？', that.$t('getapi[194]'), {
                        confirmButtonText: that.$t('getapi[1146]'),
                        cancelButtonText: that.$t('getapi[2054]'),
                        type: 'warning'
                    })
                        .then(() => {
                            let parm = that.selectData
                            that.$http.urlpost('GL/Receive/CreateSaleInvoiceVouch', parm, function (res) {
                                console.log(res);
                                if (res.Success == 1) {
                                    that.$message.success(that.$processdata.explainCallbackMsg(res.Msg));
                                    that.intidata();
                                }
                            })
                        })
                        .catch(() => {
                            this.$message({
                                type: 'info',
                                message: that.$t('getapi[6096]')
                            });
                        });
                } else {
                    let parm = that.selectData
                    that.$http.urlpost('GL/Receive/CreateSaleInvoiceVouch', parm, function (res) {
                        console.log(res);
                        if (res.Success == 1) {
                            that.$message.success(that.$processdata.explainCallbackMsg(res.Msg));
                            that.intidata();
                        }
                    })
                }
			},
        }
    };
</script>

<style lang="scss" scoped>

	table {
		border-collapse: separate;
		border-spacing: 0px 5px;
		td {
			padding-left: 3px;
			white-space: pre;
		}
	}
</style>
